import { colors } from 'fitify-ui'
import type { ImageTypes } from 'fitify-ui-landing/src/@types'
import AnimatedImageGroup from 'fitify-ui-landing/src/components/blocks/AnimatedImageGroup/AnimatedImageGroup'
import AnimatedImageGroupItem from 'fitify-ui-landing/src/components/blocks/AnimatedImageGroup/AnimatedImageGroupItem'
import Button from 'fitify-ui-landing/src/components/Button/Button'
import NativeImage from 'fitify-ui-landing/src/components/Image/NativeImage'
import { Text } from 'fitify-ui-landing/src/components/Text'
import { useTranslation } from 'next-i18next'

import type { CtaButton } from '@/data/features'

import {
  StyledFeature,
  StyledFeatureItem,
  StyledFeatureItemImage,
} from './Feature.Styled'

const Feature = ({
  title,
  content,
  image,
  imageSet,
  isEven,
  imageAssets,
  headlineVariant,
  ctaButton,
}: {
  title: string
  content: string
  image: string
  imageSet?: string
  isEven: boolean
  imageAssets?: ImageTypes.Asset[]
  headlineVariant: TextTypesVariants
  ctaButton?: CtaButton
}) => {
  const { t } = useTranslation()
  return (
    <StyledFeature $isEven={isEven}>
      <StyledFeatureItem $isEven={isEven}>
        <Text
          as={'h3'}
          variant={headlineVariant}
          style={{ color: `${colors.Gray900}`, fontSize: '32px' }}
        >
          {title}
        </Text>
        <Text
          as={'p'}
          variant={'feature-content'}
          style={{ color: `${colors.Gray900}` }}
        >
          {content}
        </Text>
        {ctaButton && (
          <Button href={ctaButton.url}>{t(ctaButton.title)}</Button>
        )}
      </StyledFeatureItem>
      <StyledFeatureItem $isEven={isEven}>
        <AnimatedImageGroup>
          {imageAssets &&
            imageAssets.map((item, index) => {
              return (
                <AnimatedImageGroupItem
                  key={index}
                  width={item.width}
                  label={item.label}
                  value={item.value}
                  icon={item.icon}
                  iconColor={item.iconColor}
                  position={item.position}
                />
              )
            })}
          <StyledFeatureItemImage>
            <NativeImage
              alt={title}
              src={image}
              srcSet={imageSet}
              width={'100%'}
              height={'auto'}
            />
          </StyledFeatureItemImage>
        </AnimatedImageGroup>
      </StyledFeatureItem>
    </StyledFeature>
  )
}

export default Feature
